import LoadingBackdropWrapper from '@/components/Modal/common/LoadingBackdropWrapper';
import PropTypes from 'prop-types';
import { useState } from 'react';
import UploadModal from './UploadModal';

const FileModal = ({ open, handleClose }) => {
  const [loading, setLoading] = useState(false);

  const commonModalProps = {
    open,
    setLoading,
    onModalClose: handleClose,
  };

  return (
    <LoadingBackdropWrapper backdropOpen={loading}>
      <UploadModal {...commonModalProps} />
    </LoadingBackdropWrapper>
  );
};

FileModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};

export default FileModal;
